import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, of, retry, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

type FeatureFlags = typeof environment.features;

const CACHE_KEY = 'myhub_feature_flags';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  private readonly http = inject(HttpClient);
  private flags: FeatureFlags = this.loadFromCache() ?? { ...environment.features };

  private readonly featureFlagsUrl = `${environment.apiBaseUrl}/myhub-api/feature-flags/minified`;

  load(): Observable<void> {
    return this.http.get<FeatureFlags>(this.featureFlagsUrl).pipe(
      retry({ count: 2, delay: 1000 }),
      tap((flags) => {
        this.flags = flags;
        try {
          localStorage.setItem(CACHE_KEY, JSON.stringify(flags));
        } catch {
          // on note, at this stage,flags live in memory for this session
        }
      }),
      map(() => void 0),
      catchError(() => of(void 0)),
    );
  }

  get<K extends keyof FeatureFlags>(flag: K): boolean {
    return this.flags[flag] ?? false;
  }

  private loadFromCache(): FeatureFlags | null {
    try {
      const cached = localStorage.getItem(CACHE_KEY);
      return cached ? (JSON.parse(cached) as FeatureFlags) : null;
    } catch {
      return null;
    }
  }
}
